module.exports = __webpack_public_path__ + "static/media/done_badg.86ebbb66.svg";